// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const { getCurrencySymbol, formatAmount, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ commons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ constants
const {
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_VARIABLE
} = require('constants/index');

class CardPayLaterInformation extends React.Component {
    render () {
        const { immCard, immCardPayLater, immGlobalVariables } = this.props;
        const immStepOne = immCardPayLater.getIn(['steps', 0]);
        const type = immCard.get('type');
        const number = getLastNChars(immCard.get('number'), 4, '*', 4);
        const currentPaymentMethod = immStepOne.get('method');
        const methodDescription = immStepOne.get('methodDescription').split(' ');
        const disposedBalance = immCard.get('balanceDrawn');
        const currencySymbol = getCurrencySymbol(disposedBalance);
        const plainAmountObject = getPlainAmountObject(disposedBalance);
        const amount = [];

        let additionalItemElement, interestTae, interestTin, interestMn, paymentMethod, taeExample;

        switch (currentPaymentMethod) {
            case CARD_PAYMENT_METHOD_UNIQUE:
                amount.push(methodDescription[3]);
                paymentMethod = `${formatText('contractsView-cardPaymentMethodUnique')} ${amount[0]}%`;
                break;
            case CARD_PAYMENT_METHOD_FIXED:
                amount.push(`${methodDescription[2]} ${methodDescription[3]}`);
                paymentMethod = `${formatText('contractsView-cardPaymentMethodFixed')} ${amount[0]}`;
                break;
            case CARD_PAYMENT_METHOD_VARIABLE:
                amount.push(methodDescription[4], `${methodDescription[7]} ${methodDescription[8]}`);
                paymentMethod = `${formatText('contractsView-cardPaymentMethodVariable', [amount[0], amount[1]])}`;
                break;
        }

        if (immCardPayLater.get('visibleStep') === 2) {
            const maxImportFormattedAmount = formatAmount(immStepOne.get('import'));
            const maxImport = `${maxImportFormattedAmount} ${currencySymbol}`;

            additionalItemElement = (
                <OKInformativeList>
                    <OKInformativeListItem
                        title={formatText('cardPayLater-import')}
                    >
                        {maxImport}
                    </OKInformativeListItem>
                </OKInformativeList>
            );
        }

        if (immCard.get('isDiamond')) {
            const immPackDiamondPercentages = immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', 'pago_facil_paga_despues']);
            interestMn = immPackDiamondPercentages.get('nominal');
            interestTae = immPackDiamondPercentages.get('tae');
            interestTin = immPackDiamondPercentages.get('tin');
            taeExample = formatText('cardPayLater-taePremiumDiamondExample');
        } else if(immCard.get('isPremium')) {
            const immPackPremiumPercentages = immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', 'pago_facil_paga_despues']);
            interestMn = immPackPremiumPercentages.get('nominal');
            interestTae = immPackPremiumPercentages.get('tae');
            interestTin = immPackPremiumPercentages.get('tin');
            taeExample = formatText('cardPayLater-taePremiumDiamondExample');
        } else if(immCard.get('isRevolving')) {
            const immRevolvingPackPercentages = immGlobalVariables.getIn(['variables', 'parameters', `revolving_pack_${immCard.get('revolvingPack')}`, 'pago_facil_paga_despues']);
            if(!!immRevolvingPackPercentages) {
                interestMn = immRevolvingPackPercentages.get('nominal');
                interestTae = immRevolvingPackPercentages.get('tae');
                interestTin = immRevolvingPackPercentages.get('tin');
            }
        } else {
            const immOpenCreditPercentages = immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', 'pago_facil_paga_despues']);
            interestMn = immOpenCreditPercentages.get('nominal');
            interestTae = immOpenCreditPercentages.get('tae');
            interestTin = immOpenCreditPercentages.get('tin');
            taeExample = formatText('cardPayLater-taeOpenCreditExample');
        }

        return (
            <section className="card-pay-later-information">
                <OKInformativeList columns={2}>
                    <OKInformativeListItem
                        title={formatText('cardPayLater-cardType')}
                    >
                        <FormattedText value={`cards-${type}`} />
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={formatText('cardPayLater-cardNumber')}
                    >
                        {number}
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={formatText('cardPayLater-paymentMethod')}
                    >
                        {paymentMethod}
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={formatText('cardPayLater-disposedBalance')}
                    >
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={formatText('cardPayLater-tin')}
                    >
                        {interestTin}
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={formatText('cardPayLater-tae')}
                        icon={taeExample ? "icon-informacion" : ''}
                        information={taeExample}
                        tooltipClassName="account-debit-detail__tooltip"
                    >
                        {interestTae}
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={formatText('cardPayLater-monthlyNominal')}
                    >
                        {interestMn}
                    </OKInformativeListItem>
                </OKInformativeList>
                {additionalItemElement}
            </section>
        );
    }
}

CardPayLaterInformation.propTypes = {
    immCard: PropTypes.object.isRequired,
    immCardPayLater: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object
}

module.exports = CardPayLaterInformation;
